"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Beer = function Beer(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "18px",
    height: "29px",
    viewBox: "0 0 18 29",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1205.000000, -2760.000000)",
    stroke: fill,
    strokeWidth: "2.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1206.000000, 2762.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.3333333,25.1666663 L4.66666667,25.1666663 L0.522222222,2.11111111 C0.440425303,1.62719465 0.576071288,1.1318252 0.892991392,0.757088593 C1.2099115,0.382351984 1.67588588,0.166345988 2.16666667,0.16666631 L13.8333333,0.16666631 C14.3241141,0.166345988 14.7900885,0.382351984 15.1070086,0.757088593 C15.4239287,1.1318252 15.5595747,1.62719465 15.4777778,2.11111111 L11.3333333,25.1666663 Z"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "1.33333333",
    y1: "25.1666667",
    x2: "14.6666667",
    y2: "25.1666667"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "1.07222222",
    y1: "5.16666667",
    x2: "14.9277778",
    y2: "5.16666667"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.33333333,11.8333333 C6.33333333,12.7538079 7.07952542,13.5 8,13.5 C8.92047458,13.5 9.66666667,12.7538079 9.66666667,11.8333333 C9.66666667,10.9128588 8.92047458,10.1666667 8,10.1666667 C7.07952542,10.1666667 6.33333333,10.9128588 6.33333333,11.8333333 Z"
  })))));
};
Beer.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Beer.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Beer;